/// <amd-module name="Agile/Common/Redux/TeamSettings/TeamSettingsModule" />
import { ITeamSettingsAwareState } from "Agile/Common/Redux/TeamSettings/TeamSettingsContracts";
import { teamSettingsReducer } from "Agile/Common/Redux/TeamSettings/TeamSettingsReducer";
import { loadTeamSettings } from "Agile/Common/Redux/TeamSettings/TeamSettingsSagas";
import { ISagaModule } from "redux-dynamic-modules-saga";

export const TeamSettingsModule: ISagaModule<ITeamSettingsAwareState> = {
    id: "teamsettings",
    reducerMap: { teamSettingsState: teamSettingsReducer },
    sagas: [loadTeamSettings]
};
